import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Typography,
  Button
} from "@mui/material";

import { db } from "../Config/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy
} from "firebase/firestore";

export default function HistoricoMaterial({
  open,
  onClose,
  material
}) {
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);

 useEffect(() => {
  if (!open || !material?.id) return;

  async function carregar() {
    setLoading(true);

    const q = query(
      collection(
        db,
        "tblListaMateriaisCadastrados",
        material.id,
        "historico"
      ),
      orderBy("data", "desc")
    );

    const snap = await getDocs(q);
    const registros = await Promise.all(snap.docs.map(async (documento) => {
      const dados = documento.data();
      if (dados.usuario?.email || !dados.usuario?.uid) return dados;
      try {
        const usuarioSnap = await getDoc(doc(db, "users", dados.usuario.uid));
        const email = usuarioSnap.exists() ? usuarioSnap.data()?.email || "" : "";
        return email
          ? { ...dados, usuario: { ...dados.usuario, email } }
          : dados;
      } catch {
        return dados;
      }
    }));
    setHistorico(registros);
    setLoading(false);
  }

  carregar();
}, [open, material?.id]);



  function renderDescricao(h) {
    if (h.acao === "CRIACAO") {
      return "Cadastro do material criado";
    }

    if (h.acao === "ALTERACAO_STATUS") {
      return `Status alterado de "${h.valorAnterior}" para "${h.valorNovo}"`;
    }

    if (h.acao === "EDICAO") {
      return "Dados do material alterados";
    }

    return h.acao;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        Histórico do Material — Código {material?.codigo}
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <CircularProgress />
        ) : historico.length === 0 ? (
          <Typography variant="body2">
            Nenhum histórico encontrado.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Evento</TableCell>
                <TableCell>Responsável</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {historico.map((h, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    {h.data?.toDate().toLocaleString("pt-BR")}
                  </TableCell>
                  <TableCell>{renderDescricao(h)}</TableCell>
                  <TableCell>{h.usuario?.email || h.usuario?.nome || "Usuário não identificado"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>

      {/* BOTÃO VOLTAR */}
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
